import { render, staticRenderFns } from "./ReviewSickCows.vue?vue&type=template&id=2f78c612&"
import script from "./ReviewSickCows.vue?vue&type=script&lang=js&"
export * from "./ReviewSickCows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports